export function getElementsByQuery(query: string): Element[] {
  const elements = document.querySelectorAll(query);
  return Array.from(elements);
}

export function getElementByQuery(query: string): HTMLElement {
  const element = document.querySelector(query);
  // @ts-ignore
  return element;
}
